export class GetSnapshotRecipeResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "recipe",
            "baseName": "recipe",
            "type": "SnapshotRecipe",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetSnapshotRecipeResponse.attributeTypeMap;
    }
    constructor() {
    }
}
